import CreateIdealCandidateForm from "../CreateIdealCandidateForm/CreateIdealCandidateForm";
import PotentialCandidateView from "../PotentialCandidateView/PotentialCandidateView";
import PotentialCandidateForm from "../PotentialCandidateForm";

import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Grid,
  Link,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
  Menu,
  MenuItem,
  Checkbox,
  Slider,
  alpha,   // Added
  useTheme // Added
} from "@mui/material";

import {
  Search,
  Share as ShareIcon,
  Archive as ArchiveIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import SortIcon from '@mui/icons-material/SortByAlpha'; // For Sort by Date button

import { TabContext, TabList, TabPanel } from "@mui/lab";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useState, useEffect } from "react";
import moment from "moment";
import SearchIcon from '@mui/icons-material/Search'
import { useTour } from '../../shared/TourContext';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';


function getSearchUrl() {
  switch (process.env.REACT_APP_ENV) {
    case "production":
      return "https://app-gcp.candidatetools.com/search/";
    case "staging":
      return "https://app-qa-gcp.candidatetools.com/search/";
    default:
      return "https://app-dev-gcp.candidatetools.com/search/";
  }
}

const formatUTCToLocal = (ts) =>
  moment.unix(ts).format("YYYY-MM-DD hh:mm A");

const formatPhoneNumber = (str) =>
  /^\+1\d{10}$/.test(str)
    ? str.replace(/^(\+1)(\d{3})(\d{3})(\d{4})$/, "$1 ($2) $3-$4")
    : str;

const scoreToColor = (score) => {
  const numericScore = Number(score);
  if (isNaN(numericScore)) return '#808080';
  return numericScore <= 0.5 ? "#D0312D" : numericScore <= 0.75 ? "#FC6A03" : "#028A0F";
}

const sortBySkillScore = (cands) =>
  [...cands].sort(
    (a, b) => {
      const scoreA = a.scorecardResults?.find((s) => s.scorecardName === "skills")?.score || 0;
      const scoreB = b.scorecardResults?.find((s) => s.scorecardName === "skills")?.score || 0;
      return scoreB - scoreA;
    }
  );

const statusLabel = (s) =>
  ({ approved: "Approved", pending: "Pending", declined: "Declined" }[s] ||
   "Unknown");


const statusColor = (s) =>
  ({ approved: "success", pending: "primary", declined: "error" }[s] ||
   "warning");


const ArchiveConfirmationDialog = ({ open, onCancel, onConfirm }) => (
  <Dialog open={open} onClose={onCancel} PaperProps={{ sx: { borderRadius: 4 } }}>
    <DialogTitle>Archive Candidate?</DialogTitle>
    <DialogContent>
      <Typography color="textSecondary" variant="body2">
        This will hide the candidate. You can restore later.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button
        color="error"
        onClick={onConfirm}
        sx={{ textTransform: "none", borderRadius: "20px" }}
      >
        Archive
      </Button>
      <Button
        onClick={onCancel}
        sx={{ textTransform: "none", borderRadius: "20px" }}
      >
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

const CreatePotentialCandidateDialog = ({ open, idealCandidate, onSubmit, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    fullWidth
    PaperProps={{ sx: { borderRadius: 4 } }}
  >
    <DialogTitle>Create Potential Candidate</DialogTitle>
    <DialogContent>
      <PotentialCandidateForm
        showSuccess={false}
        includeHeader={false}
        idealCandidate={idealCandidate}
        onSubmit={onSubmit}
      />
    </DialogContent>
  </Dialog>
);

function getPassiveSearchPath() {
  return "/passive-search";
}

export default function IdealCandidateView({
  idealCandidate,
  potentialCandidates,
  onArchive,
  onUnarchive,
  onShare,
  onCreatePotentialCandidate,
  initialStatuses: initialStatusesFromProps = ["approved", "pending"],
  initialSkillScore: initialSkillScoreFromProps = 0,
  initialBehaviorScore: initialBehaviorScoreFromProps = 0,
}) {
  const theme = useTheme(); // Added for styling
  const [currentTab, setCurrentTab] = useState("potential-candidates");
  const [viewEmail, setViewEmail] = useState(null);
  const [openArchive, setOpenArchive] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);

  const [selectedStatuses, setSelectedStatuses] = useState(initialStatusesFromProps);
  const [skillsValue, setSkillsValue] = useState(initialSkillScoreFromProps);
  const [behaviorsValue, setBehaviorsValue] = useState(initialBehaviorScoreFromProps);
  const [sortOrder, setSortOrder] = useState('asc');

  useEffect(() => {
    setSelectedStatuses(initialStatusesFromProps);
  }, [initialStatusesFromProps]);

  useEffect(() => {
    setSkillsValue(initialSkillScoreFromProps);
  }, [initialSkillScoreFromProps]);

  useEffect(() => {
    setBehaviorsValue(initialBehaviorScoreFromProps);
  }, [initialBehaviorScoreFromProps]);

  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const [skillAnchorEl, setSkillAnchorEl] = useState(null);
  const [behaviorAnchorEl, setBehaviorAnchorEl] = useState(null);

  const navigateInternal = useNavigate();

  const handleSearch = () => {
    const passiveSearchPath = getPassiveSearchPath();
    const jobDescriptionString = idealCandidate?.description;

    console.log(`IdealCandidateView: Navigating to ${passiveSearchPath} with job description.`);
    navigateInternal(passiveSearchPath, {
      state: {
        jobDescription: jobDescriptionString 
      }
    });
  };

  const handleConfirmArchive = async () => {
    await onArchive();
    setOpenArchive(false);
  };

  const handleCreateClick = (formValues) => {
    onCreatePotentialCandidate({
      ...formValues,
      criteria: idealCandidate?.criteria || {},
    });
    setOpenCreate(false);
  };

  const toggleStatus = (s) => {
    setSelectedStatuses((prev) =>
      prev.includes(s)
        ? prev.filter((x) => x !== s)
        : [...prev, s]
    );
  };

  const handleSliderChange = (_, v, type) =>
    type === "skills"
      ? setSkillsValue(v)
      : setBehaviorsValue(v);

  const onApplyFilters = () => { // Renamed for clarity, used by new APPLY button
    setStatusAnchorEl(null);
    setSkillAnchorEl(null);
    setBehaviorAnchorEl(null);
  };

  const onReset = () => {
    setSelectedStatuses(initialStatusesFromProps);
    setSkillsValue(initialSkillScoreFromProps);
    setBehaviorsValue(initialBehaviorScoreFromProps);
    setSortOrder('asc');
    setStatusAnchorEl(null);
    setSkillAnchorEl(null);
    setBehaviorAnchorEl(null);
  };

  const toggleSortOrder = () => {
    setSortOrder(prevOrder => prevOrder === 'asc' ? 'desc' : 'asc');
  };

  const getProcessedCandidates = () => {
    if (!potentialCandidates) return [];
    let processed = [...potentialCandidates];
    if (selectedStatuses && selectedStatuses.length > 0) {
      processed = processed.filter(pc => selectedStatuses.includes(pc.status));
    }
    processed = processed.filter(pc => {
      const skillScoreObj = pc.scorecardResults?.find(sc => sc.scorecardName === "skills");
      const actualSkillScore = (skillScoreObj?.score ?? 0) * 100;
      return actualSkillScore >= skillsValue;
    });
    processed = processed.filter(pc => {
      const behaviorScoreObj = pc.scorecardResults?.find(sc => sc.scorecardName === "behaviors");
      const actualBehaviorScore = (behaviorScoreObj?.score ?? 0) * 100;
      return actualBehaviorScore >= behaviorsValue;
    });
    if (sortOrder === 'asc') {
      processed.sort((a, b) => (a.createdAt || 0) - (b.createdAt || 0));
    } else if (sortOrder === 'desc') {
      processed.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
    }
    return processed;
  };

  // Styles adapted from the snippet
  const filterButtonSx = {
    textTransform: 'none',
    minWidth: { xs: 120, sm: 140 },
    justifyContent: 'space-between',
    borderColor: theme.palette.divider,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper, // Or theme.palette.grey[100] for slight off-white
    fontSize: '0.875rem',
    fontWeight: 400,
    '& .MuiButton-endIcon': { ml: 'auto' },
    '&:hover': {
        borderColor: theme.palette.grey[500], // Darker border on hover
        backgroundColor: alpha(theme.palette.action.hover, 0.08) // Slightly more pronounced hover
    }
  };

  const menuPaperPropsSx = {
    elevation: 3, // Slightly more pronounced shadow
    sx: {
        borderRadius: '8px',
        mt: 0.75, // Adjusted margin top
        minWidth: '200px', // Adjusted min width
        boxShadow: theme.shadows[3]
    }
  };
  // --- Page specific tour stuff ---
  const { setSteps } = useTour();
  useEffect(() => {
    setSteps([
      {
        title: (<div className="text-center"><strong className="text-xl">Welcome to Your Candidate Dashboard</strong></div>),
        content: (
          <div className="space-y-2">
            <p>This dashboard helps you efficiently manage applicants for your open position.</p>
            <p className="text-sm text-gray-600">We'll guide you through the key features to help you find your ideal candidates.</p>
          </div>
        ),
        placement: "center",
        target: "body",
        disableBeacon: true,
      },
      {
        target: '[data-tour="potential-candidates-tab"]',
        content: (
          <div className="space-y-2">
            <h4 className="font-semibold">Potential Candidates Tab</h4>
            <p>Review all applicants who applied your position.</p>
            <ul className="list-disc pl-4 text-sm text-gray-700">
              <li>View candidate profiles at a glance</li>
              <li>See match scores for easy comparison</li>
              <li>Quick-action buttons for efficient screening</li>
            </ul>
          </div>
        ),
        disableBeacon: true,
        placement: "right",
      },
      {
        target: '[data-tour="details-tab"]',
        content: (
          <div className="space-y-2">
            <h4 className="font-semibold">Position Details</h4>
            <p>Access comprehensive information about your job posting:</p>
            <ul className="list-disc pl-4 text-sm text-gray-700">
              <li>Full job description and requirements</li>
              <li>Key skills and behaviors needed</li>
              <li>Scoring criteria and weightings</li>
            </ul>
          </div>
        ),
        disableBeacon: true,
        placement: "bottom",
      },
      {
        target: '[data-tour="filters"]',
        content: (
          <div className="space-y-2">
            <h4 className="font-semibold">Advanced Filtering</h4>
            <p>Narrow down candidates using precise filters:</p>
          </div>
        ),
        disableBeacon: true,
        placement: "left",
      },
      {
          target: '[data-tour="passive-search"]',
          title: 'Passive Candidate Search',
          content: (
              <div className="space-y-2">
                  <p>Discover qualified candidates that might be perfect for your role.</p>
                  <p className="text-sm text-gray-500">Our system scans profiles and suggests potential matches based on your requirements.</p>
              </div>
          ),
          disableBeacon: true,
          placement: "bottom",
      }
    ]);
      
      return () => setSteps([]); 
    }, []);

  return (
    <Paper sx={{ borderRadius: 6, p: {xs: 2, md: 4} }}> {/* Responsive Bakcpadding */}

      {/* Header & Actions */}
      <Grid container alignItems="center" spacing={{xs: 1, md:3}} sx={{ mb: 3 }}> {/* Responsive spacing */}
        <Grid item>
          <Typography variant="h4" sx={{ fontWeight: 400 }}>
            {idealCandidate?.title}
          </Typography>
        </Grid>
        <Grid item xs />
        <Grid item>
          <Stack direction={{xs: "column", sm: "row"}} spacing={{xs:1, sm:2}} alignItems="center"> {/* Responsive stack */}
            <Button 
              data-tour="passive-search"
              variant="outlined"
              size="small"
              color="primary"
              startIcon={<Search />}
              onClick={handleSearch}
              sx={{ textTransform: "none", borderRadius: "20px" }}
            >
              Passive Search
            </Button>

            {!idealCandidate?.archivedAt ? (
              <Button 
              variant="text" 
              startIcon={<ArchiveIcon />} 
              onClick={() => setOpenArchive(true)} 
              sx={{ textTransform: "none", borderRadius: "20px" }}>
                ARCHIVE
              </Button>
            ) : (
              <Button 
              variant="text" 
              startIcon={<ArchiveIcon />} 
              onClick={onUnarchive} 
              sx={{ textTransform: "none", borderRadius: "20px" }}>
                UNARCHIVE
              </Button>
            )}
            <ArchiveConfirmationDialog open={openArchive} onCancel={() => setOpenArchive(false)} onConfirm={handleConfirmArchive} />

            <Button 
            variant="outlined" 
            startIcon={<ShareIcon />} 
            onClick={onShare} 
            sx={{ textTransform: "none", borderRadius: "20px" }}>
              SHARE
            </Button>

            <Button 
            variant="contained" 
            startIcon={<AddIcon />} 
            onClick={() => setOpenCreate(true)} 
            sx={{ textTransform: "none", borderRadius: "20px" }}>
              ADD CANDIDATE
            </Button>
            <CreatePotentialCandidateDialog open={openCreate} onClose={() => setOpenCreate(false)} idealCandidate={idealCandidate} onSubmit={handleCreateClick} />
          </Stack>
        </Grid>
      </Grid>

      {/* Filters & Controls */}
      <Paper data-tour="filters" variant="outlined" sx={{p:2.5, borderRadius: '12px', borderColor: theme.palette.divider, backgroundColor: alpha(theme.palette.grey[50], 0.6), mb: 3}}>
        <Grid container spacing={{xs: 1.5, sm: 2}} alignItems="flex-end">
          {/* Status Menu */}
          <Grid item xs={12} sm={6} md="auto">
              <Typography variant="caption" display="block" color="textSecondary" sx={{mb:0.5, ml:0.5}}>Status</Typography>
              <Button variant="outlined" size="small" onClick={(e) => setStatusAnchorEl(e.currentTarget)} endIcon={<ArrowDropDownIcon />} sx={filterButtonSx}>
                  {selectedStatuses.length === 3 || selectedStatuses.length === 0 ? "All Statuses" : selectedStatuses.map(s => statusLabel(s)).join(', ')}
              </Button>
              <Menu
                  anchorEl={statusAnchorEl}
                  open={Boolean(statusAnchorEl)}
                  onClose={() => setStatusAnchorEl(null)}
                  PaperProps={menuPaperPropsSx}
              >
                  {["approved", "pending", "declined"].map((statusKey) => (
                      <MenuItem key={statusKey} onClick={() => {toggleStatus(statusKey); /* setStatusAnchorEl(null);  if we want it to close after the user changes filter */}} sx={{fontSize: '0.875rem'}}>
                          <Checkbox size="small" checked={selectedStatuses.includes(statusKey)} sx={{mr:0.5, p:0.5}}/>
                          {statusLabel(statusKey)}
                      </MenuItem>
                  ))}
              </Menu>
          </Grid>

          {/* Skills Menu */}
          <Grid item xs={12} sm={6} md="auto">
              <Typography variant="caption" display="block" color="textSecondary" sx={{mb:0.5, ml:0.5}}> Skill Score</Typography>
              <Button variant="outlined" size="small" onClick={(e) => setSkillAnchorEl(e.currentTarget)} endIcon={<ArrowDropDownIcon />} sx={filterButtonSx}>
                  {skillsValue}%
              </Button>
              <Menu
                  anchorEl={skillAnchorEl}
                  open={Boolean(skillAnchorEl)}
                  onClose={() => setSkillAnchorEl(null)}
                  PaperProps={menuPaperPropsSx}
                  MenuListProps={{ sx: { py: 0 } }}
              >
                  <Box width={{xs: 240, sm: 275}} px={2.5} py={2}>
                      <Slider
                          marks={[{value: 0, label: '0%'}, {value: 100, label: '100%'}]}
                          value={skillsValue}
                          onChange={(e, val) => handleSliderChange(e, val, 'skills')}
                          step={5} min={0} max={100}
                          valueLabelDisplay="auto"
                          size="small"
                      />
                  </Box>
              </Menu>
          </Grid>

          {/* Behaviors Menu */}
          <Grid item xs={12} sm={6} md="auto">
              <Typography variant="caption" display="block" color="textSecondary" sx={{mb:0.5, ml:0.5}}> Behavior Score</Typography>
              <Button variant="outlined" size="small" onClick={(e) => setBehaviorAnchorEl(e.currentTarget)} endIcon={<ArrowDropDownIcon />} sx={filterButtonSx}>
                  {behaviorsValue}%
              </Button>
              <Menu
                  anchorEl={behaviorAnchorEl}
                  open={Boolean(behaviorAnchorEl)}
                  onClose={() => setBehaviorAnchorEl(null)}
                  PaperProps={menuPaperPropsSx}
                  MenuListProps={{ sx: { py: 0 } }}
              >
                   <Box width={{xs: 240, sm: 275}} px={2.5} py={2}>
                      <Slider
                          marks={[{value: 0, label: '0%'}, {value: 100, label: '100%'}]}
                          value={behaviorsValue}
                          onChange={(e, val) => handleSliderChange(e, val, 'behaviors')}
                          step={5} min={0} max={100}
                          valueLabelDisplay="auto"
                          size="small"
                      />
                  </Box>
              </Menu>
          </Grid>
          
          {/* Sort Button for Application Date */}
          <Grid item xs={12} sm={6} md="auto">
              <Typography variant="caption" display="block" color="textSecondary" sx={{mb:0.5, ml:0.5}}>Sort by Date</Typography>
              <Button
                  variant="outlined"
                  size="small"
                  onClick={toggleSortOrder}
                  startIcon={<SortIcon sx={{ transform: sortOrder === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.2s', fontSize: '1.125rem' }} />}
                  sx={{...filterButtonSx, minWidth: {xs: 120, sm: 150}}}
              >
                  {sortOrder === 'asc' ? 'Oldest First' : 'Newest First'}
              </Button>
          </Grid>

          <Grid item xs /> 
          {/* Spacer */}
          <Grid item xs={12} md="auto">
              <Stack direction={{xs: "column", sm:"row"}} spacing={1.5} alignItems="center" sx={{width: '100%', justifyContent: {xs:'stretch', sm:'flex-end'}, mt:{xs:2, sm:0, md: 'auto' } }}> 
                  <Button size="small" variant="contained" onClick={onReset} sx={{ textTransform: 'none', borderRadius: '18px', px: 3, py: 0.75, boxShadow: theme.shadows[1], '&:hover': {boxShadow: theme.shadows[3]}, width: {xs:'100%', sm:'auto'} }}>
                      RESET FILTER
                  </Button>
              </Stack>
          </Grid>
        </Grid>
      </Paper>

      {/* Tabs for Potential Candidates and Details */}
      <TabContext value={currentTab}>
        <TabList
          onChange={(_, v) => setCurrentTab(v)}
          centered // Centers the tabs within the TabList
          indicatorColor="primary"
          sx={{
            mb: 0, // Adjusted margin
            borderBottom: 1, 
            borderColor: 'divider',
            '& .MuiTabs-indicator': {
              height: '3px', // Thicker indicator
              // backgroundColor: theme.palette.primary.main, // Set by indicatorColor="primary"
            },
            '& .MuiTab-root': { // Common styles for all tabs
              textTransform: 'none',
              fontWeight: 500, 
              fontSize: '0.9rem', // Adjusted font size
              padding: '12px 24px', // Adjusted padding
              color: theme.palette.text.secondary, // Softer color for non-selected tabs
              minWidth: {xs: '100px', sm:'160px'}, // Responsive minWidth
              '&.Mui-selected': {
                fontWeight: 600, 
                color: theme.palette.primary.main, 
              },
              '&:hover': {
                backgroundColor: alpha(theme.palette.action.hover, 0.06), // Subtle hover
                borderRadius: '6px 6px 0 0' 
              }
            }
          }}
        >
          <Tab data-tour="potential-candidates-tab" label="Potential Candidates" value="potential-candidates" />
          <Tab data-tour="details-tab" label="Details" value="details" />
        </TabList>

        <TabPanel value="potential-candidates" sx={{ p: 0 }}>
          <TableContainer
            component={Paper}
            sx={{ borderRadius: 4, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {[
                    "Name",
                    "Email",
                    "Phone",
                    "Applied At",
                    "Skill Score",
                    "Behavior Score",
                    "Status",
                  ].map((h) => (
                    <TableCell key={h}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {getProcessedCandidates().map((pc, index) => (
                  <TableRow
                    key={`${pc.candidate?.email || `candidate-${index}`}-${pc.createdAt}-${index}`}
                    hover
                    sx={{ "&:hover": { bgcolor: "action.hover" } }}
                  >
                    <TableCell>
                      <Link
                        component="button"
                        onClick={() => setViewEmail(pc.candidate?.email)} 
                        sx={{
                          display: "inline-block",
                          maxWidth: 180,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {pc.candidate.name}
                      </Link>
                    </TableCell>
                    <TableCell>{pc.candidate.email}</TableCell>
                    <TableCell>{formatPhoneNumber(pc.candidate.phone)}</TableCell>
                    <TableCell>{formatUTCToLocal(pc.createdAt)}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={`${Math.round(
                          pc.scorecardResults.find((s) => s.scorecardName === "skills")
                            .score *
                            100
                        )}%`}
                        sx={{
                          bgcolor: scoreToColor(
                            pc.scorecardResults.find((s) => s.scorecardName === "skills")
                              .score
                          ),
                          color: "#fff",
                          borderRadius: 4,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={`${Math.round(
                          pc.scorecardResults.find((s) => s.scorecardName === "behaviors")
                            .score *
                            100
                        )}%`}
                        sx={{
                          bgcolor: scoreToColor(
                            pc.scorecardResults.find((s) => s.scorecardName === "behaviors")
                              .score
                          ),
                          color: "#fff",
                          borderRadius: 4,
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Chip
                        label={statusLabel(pc.status)}
                        color={statusColor(pc.status)}
                        sx={{ fontWeight: "bold", borderRadius: 4 }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>

        <TabPanel value="details">
          <CreateIdealCandidateForm 
          initialData={idealCandidate} 
          viewOnly = {true} />
        </TabPanel>

        <Dialog
          open={Boolean(viewEmail)}
          onClose={() => setViewEmail(null)}
          maxWidth="lg"
          PaperProps={{ sx: { borderRadius: 4 } }}
        >
          <DialogContent>
            <PotentialCandidateView
              idealCandidate={idealCandidate}
              potentialCandidate={potentialCandidates.find(
                (pc) => pc.candidate.email === viewEmail
              )}
              onClose={() => setViewEmail(null)}
            />
          </DialogContent>
        </Dialog>
      </TabContext>
    </Paper>
  );
}
